<script lang="ts">

  import Navigation from "../_components/navigation.svelte"

</script>

<main class="overflow-auto relative mx-auto h-full max-w-3xl">
  <nav class="sticky w-full top-0 inset-s-0 inset-e-0 z-10 bg-background border-b max-w-3xl">
    <div class="flex h-12 items-center justify-between px-3">
      <div class="flex items-center">
        <h1 class="text-lg font-medium">Notifikasi</h1>
      </div>
      <div></div>
    </div>
  </nav>
  <section class="flex h-dvh items-center justify-center">
    <div>Dalam pengembangan</div>
  </section>
  <Navigation/>
</main>
